import { Stack } from '@mui/material';

import { SpinningIcon } from '@/components/animation/SpinningIcon/SpinningIcon';
import { EstateTabEmptyState } from '@/modules/estate/components/EstateTabEmptyState';
import { useEstateHoldingsContext as useEstateDirectHoldingsContext } from '@/modules/estate/contexts/estateHoldings.context';
import { DirectHoldingsGroupContainer } from '@/modules/estate/EstateDirectHoldings/DirectHoldingsGroupContainer/DirectHoldingsGroupContainer';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { COLORS } from '@/styles/tokens/colors';

export function EstateDirectHoldings() {
  const { primaryClients } = useHouseholdDetailsContext();
  const { loading, entities } = useEstateDirectHoldingsContext();

  const hasExistingData = entities && entities.length > 0;

  if (loading && !hasExistingData) {
    return (
      <Stack
        height="40px"
        direction="row"
        alignItems="center"
        justifyContent="center"
      >
        <SpinningIcon sx={{ color: COLORS.TEXT.SECONDARY }} />
      </Stack>
    );
  }

  if (entities?.length === 0) {
    return <EstateTabEmptyState variant={'direct-holdings'} />;
  }

  return (
    <Stack spacing={5}>
      {(primaryClients ?? []).length > 1 && (
        <DirectHoldingsGroupContainer variant={'joint'} />
      )}
      {(primaryClients ?? []).map((client) => (
        <DirectHoldingsGroupContainer
          variant={'individual'}
          clientProfile={client}
          key={client.id}
        />
      ))}
      {primaryClients && (
        <DirectHoldingsGroupContainer
          variant={'other'}
          primaryClients={primaryClients}
        />
      )}
    </Stack>
  );
}
